interface StoryView {
  chapters: Array<{
    title: string;
    index: string;
    coverImgUrl: string;
    url: string;
    locked: boolean;
    tag: string;
  }>;
}

const defaultStoryView = { chapters: [] };

export { StoryView, defaultStoryView };